import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class CertificateRestraints extends AdminOnlyItemRestraints {
  canViewItem(item) {
    return true;
  }
}